import { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { useAppDispatch } from '@/store';
import { getItem } from '../../../actions/pdp.actions';

export const useCapacitySync = ({ extraData, variants }) => {
  const [fallback, setFallback] = useState(-1);
  const pauseSync = useRef(true);
  const dispatch = useAppDispatch();

  const activeCapacityIdx = useMemo(() => {
    if (fallback >= 0 && pauseSync.current === true) {
      pauseSync.current = false;
      return fallback;
    }
    if (!extraData || !variants?.activeSize || !extraData?.capacity?.sizes) {
      return 0;
    } else {
      const result = extraData.capacity.sizes.findIndex((x) => x.value === variants.activeSize.value);
      pauseSync.current = true;
      setFallback(-1);
      return result;
    }
  }, [extraData, variants, fallback]);

  const setActiveCapacityIdx: React.Dispatch<React.SetStateAction<number>> = useCallback(
    (value) => {
      let newActiveCapacityIdx: number;
      if (typeof value === 'function') {
        newActiveCapacityIdx = value(activeCapacityIdx);
      } else {
        newActiveCapacityIdx = value;
      }
      if (newActiveCapacityIdx === activeCapacityIdx) {
        setFallback(-1);
        return;
      }
      if (newActiveCapacityIdx >= 0) {
        const url = variants.sizes.find(
          (s) => s.value === extraData.capacity.sizes[newActiveCapacityIdx].value
        )?.url;
        if (!!url) {
          dispatch(getItem(url));
          setFallback(-1);
        } else {
          pauseSync.current = true;
          setFallback(newActiveCapacityIdx);
        }
      }
    },
    [dispatch, getItem, extraData, variants]
  );

  return [activeCapacityIdx, setActiveCapacityIdx] as const;
};

export const useCapacitySyncCMS = (sizeId) => {
  const { variants } = useSelector((state: any) => state.pdpItem);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!variants?.sizes) return;

    if (variants?.activeSize?.id !== sizeId) {
      const url = variants.sizes.find(s => s.id === sizeId)?.url;
      if (url) {
        dispatch(getItem(url));
      }
    }
  }, [ sizeId ]);
};